/* Mount the bookstore assistant on a plain shelf page (collection, search).
 *
 * The walkable scene mounts her itself, from walkable.js, because it has a room
 * to stand her in and a shelf it can walk to without a page load. Here there is
 * neither: she is a portrait in the corner, and following her anywhere means
 * following a link - which is assistant.js's own default. So this is only the
 * two lines of glue, kept out of Liquid where it cannot be linted or read.
 */
(function () {
  "use strict";
  var data = window.BW_ASSISTANT;
  if (!data || !data.endpoint || !window.BookwormsAssistant) return;
  window.BookwormsAssistant.mount({
    endpoint: data.endpoint,
    faces: data.faces,   // BW-352: her per-outfit expression table, all 21 files
    greeting: data.greeting,
    mode: "mini",
    shelf: data.shelf   // she speaks up if this shelf turns out to be a poor one
  });
})();
